import axios from "axios";

export const API_BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${API_BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(err, fallback = "Something went wrong.") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (typeof d === "object") {
    // FastAPI HTTPException(detail=...) can ship an object — many of our
    // routers use {code, message, ...extra} for structured error payloads.
    // Prefer the human-readable field so toasts never read "[object Object]".
    if (typeof d.message === "string") return d.message;
    if (typeof d.msg === "string") return d.msg;
    if (typeof d.detail === "string") return d.detail;
  }
  return fallback;
}
